import Vue from "vue";
import { mapGetters, mapState } from "vuex";

import comboComponent from "@/components/child/form/combo.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import { Component, Prop, Watch } from "@/decorators";
import NotaFiscalEntradaItemModel from "@/models/notaFiscalEntradaItemModel";
import PaginationModel from "@/models/paginationModel";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import UsuarioModel from "@/models/usuarioModel";
import IndicesConversoesUnidadeMedidasService from "@/services/indicesConversoesUnidadeMedidaService";
import ProdutoLoteService from "@/services/produtoLoteService";
import unidadeMedidaService from "@/services/unidadeMedidaService";
import { AppState, Getters, SessionActions } from "@/store/store";
import { getProdutoLoteCombo } from "@/utils/common/combo/combotext";

@Component({
    components: {
        decimalComponent,
        comboComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
        ...mapGetters(["GET_IS_FRACIONAMENTO", "GET_IS_ESTEREIS"] as Getters),
    },
})
export default class ItemComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;
    GET_IS_ESTEREIS: () => Promise<boolean>;

    isFracionamento = false;
    isEstereis = false;

    private produtoLoteOptions = [];
    private unidadeMedidaOptions = [];

    model = new NotaFiscalEntradaItemModel();

    @Prop(Object) item;
    @Prop(Object) indicesConversoesUnidadeMedidasService;

    private async load() {
        this.model.updateFrom(this.item);

        this.unidadeMedidaOptions = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId);
        this.model.unidadeMedidaId = this.unidadeMedidaOptions.find(p => p.text == this.model.unidadeMedida)?.value;

        try {
            const data = await new ProdutoLoteService()
                .listFilterProduto(this.model.produtoId, -10000.0, 0, 1, 999999)
                .resolveWithJSON<PaginationModel<ProdutoLoteModel>>();

            const itemNf = data.list.filter(item => item.id == this.model.produtoLoteId);
            const exibeCodigo = this.isFracionamento || this.isEstereis;
            this.produtoLoteOptions = itemNf.map(item => getProdutoLoteCombo(item, exibeCodigo));
        } catch {}
    }

    @Watch("model", { deep: true })
    private async onChangeModel() {
        this.$emit("onChangeItem", this.model);

        const indiceConversaoService = this
            .indicesConversoesUnidadeMedidasService as IndicesConversoesUnidadeMedidasService;

        const indiceConversao = await indiceConversaoService.getIndiceConversao(
            this.model.produto.unidadeMedidaEstoqueId,
            this.model.unidadeMedidaId,
        );

        this.model.quantidadeADevolverEstoque = this.model.quantidadeADevolver / indiceConversao;
    }

    private async mounted() {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);
        this.isFracionamento = await this.GET_IS_FRACIONAMENTO();
        this.isEstereis = await this.GET_IS_ESTEREIS();

        this.load();
    }
}
